__webpack_require__.p = "/wp-content/plugins/mtm-react-app-v3/frontend/build/";